import { Component, Input, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';


@Component({
  selector: 'app-student-academic-qualification',
  templateUrl: './student-academic-qualification.component.html',
  styleUrls: ['./student-academic-qualification.component.scss']
})
export class StudentAcademicQualificationComponent implements OnInit {
  @Input() studentDetails: any;
  @Input() applicationData: any;
  @Output() updatedProfileData = new EventEmitter<boolean>();

  public isLoading: boolean = false;
  public dataModel: string = "users";
  public model: any = {};
  layoutEducation: FormlyFieldConfig[] = [];
  userDetails: any;
  saveChangesEducation: boolean = false;
  getUserDetails: any;
  loading: boolean = false;
  countryOptions = this.configService.getConfig1("foreignAssist", "countries");
  courseFinderCountryOptions = this.configService.getConfig('foreignAssist', "courseFinderCountryOptions");
  stateOptions = this.configService.getConfig("foreignAssist", "states")

  educationLevelOptions = [
    { label: 'Phd', value: 'phd' },
    { label: 'Postgraduate', value: 'postgraduate' },
    { label: 'Undergraduate', value: 'undergraduate' },
    { label: 'Grade 12th', value: 'grade12' },
    { label: 'Grade 10th', value: 'grade10' }
  ];
  gradingSystemOptions = [
    { label: 'Percentage(out of 100)', value: 100 },
    { label: 'Out of 200', value: 200 },
    { label: 'CGPA (10)', value: 10 },
    { label: 'CGPA (9)', value: 9 },
    { label: 'CGPA (7)', value: 7 },
    { label: 'CGPA (5)', value: 5 },
    { label: 'CGPA (4)', value: 4 },
  ];


  _highSchoolStateOptions
  set highSchoolStateOptions(value: any[]) {
    this._highSchoolStateOptions = [...value];
  }
  get highSchoolStateOptions(): any[] {
    return this._highSchoolStateOptions;
  }

  highSchoolBoardOptions: any;


  previousHighSchoolCountry: any;
  previousHighSchoolState: any;
  highSchoolStateSelected: any;
  highSchoolBoardSelected: any;
  showhighSchoolStateAndBoardInput: boolean = false;


  _tenthGradeStateOptions
  set tenthGradeStateOptions(value: any[]) {
    this._tenthGradeStateOptions = [...value]
  }
  get tenthGradeStateOptions(): any[] {
    return this._tenthGradeStateOptions;
  }

  tenthSchoolBoardOptions: any;

  showSchoolStateAndBoardInput10: boolean = false;
  previousTenthGradeCountry: any;
  previousTenthGradeState: any;
  tenthGradeStateSelected: any;
  tenthGradeBoardSelected: any

  constructor(
    private configService: ConfigService,
    private apiHelper: ApiHelperService,
    private cd: ChangeDetectorRef,
    private userIdentity: UserIdentityService
  ) {
    this.getUserDetails = this.userIdentity.getUserDetails();
  }

  ngOnInit(): void {
    this.dataPreProcessor();
    this.userDetails = this.studentDetails;
    console.info(this.courseFinderCountryOptions)

  }

  openEditSection(key: string) {
    if (key === 'saveChangesEducation') {
      this.saveChangesEducation = true;
      this.dataPreProcessor();
    }
  }

  public triggerSubmit(): void {
    if (this.saveChangesEducation === true) {
      this.onSubmit();
    }
  }



  setLayout() {
    this.layoutEducation = undefined;
    const layoutEducation = [
      {
        fieldGroupClassName: 'row mb-4',
        validators: {
          validation: [{ name: 'checkEndTime', options: { errorPath: 'end' } }]
        },
        fieldGroup: [

          // Education Summary
          {
            template: '<h5 class="mb-3">Education Summary</h5>'
          },
          {
            className: 'col-md-6',
            key: 'countryOfEducation',
            type: 'select',
            templateOptions: {
              label: 'Country of Education*',
              options: this.courseFinderCountryOptions,
              placeholder: 'Select country'
            }
          },
          {
            className: 'col-md-6',
            key: 'highestLevel',
            type: 'select',
            templateOptions: {
              label: 'Highest Level of Education*',
              options: this.educationLevelOptions,
              placeholder: 'Select level'
            },

          },

          //Phd Section
          {
            template: '<h5 class="mb-3 mt-6">Phd Details</h5>',
            className: 'col-12',
            hideExpression: 'model.highestLevel !== "phd"'
          },
          {
            fieldGroupClassName: 'row mt-2',
            fieldGroup: [
              {
                className: 'col-md-4',
                key: 'phdMarks.country',
                type: 'select',
                templateOptions: {
                  label: 'Country of Study*',
                  options: this.courseFinderCountryOptions,
                  placeholder: 'Select Country'
                }
              },
              {
                className: 'col-md-4',
                key: 'phdMarks.state',
                type: 'input',
                templateOptions: {
                  label: 'State of Study*',

                  options: this.stateOptions,
                  placeholder: 'Select'
                }
              },
              {
                className: 'col-md-4',
                key: 'phdMarks.level',
                type: 'select',
                templateOptions: {
                  label: 'Level of Study*',
                  options: [
                    { label: 'Phd', value: 'phd' }
                  ],
                  placeholder: 'Select level'
                },
              },
              {
                className: 'col-md-6',
                key: 'phdMarks.postgradCollegeName',
                type: 'input',
                templateOptions: {
                  label: 'Name of University*',

                  placeholder: 'Enter university name'

                }
              },
              {
                className: 'col-md-6',
                key: 'phdMarks.degreeType',
                type: 'input',
                templateOptions: {
                  label: 'Qualification Achieved/ Degree Awarded*',

                  placeholder: 'eg. M.Tech, M.E., M.Sc.'
                }
              },
              {
                className: 'col-md-6',
                key: 'phdMarks.city',
                type: 'input',
                templateOptions: {
                  label: 'City of Study*',

                  placeholder: 'Enter city'
                }
              },
              {
                className: 'col-md-3',
                key: 'phdMarks.scoreSystem',
                type: 'select',
                templateOptions: {
                  label: 'Grading system & Marks scored*',

                  options: this.gradingSystemOptions,
                  placeholder: 'Select'
                }
              },
              {
                className: 'col-md-3 custom-margin-top',
                key: 'phdMarks.score',
                type: 'input',
                templateOptions: {
                  type: 'number',
                  label: 'Score*',
                  placeholder: 'Enter Marks'
                },
                expressionProperties: {
                  'templateOptions.min': '0',
                  'templateOptions.max': 'model.phdMarks.scoreSystem'
                },
                validation: {
                  messages: {
                    min: 'Score must be at least 0',
                    max: 'Score cannot exceed the max Score value'
                  }
                }
              },
              {
                className: 'col-md-6',
                key: 'phdMarks.language',
                type: 'input',
                templateOptions: {
                  label: 'Primary Language of Instruction*',

                  placeholder: 'Enter Language'
                }
              },
              {
                className: 'col-md-6',
                key: 'phdMarks.degreeBacklogs',
                type: 'input',
                templateOptions: {
                  label: 'Backlogs*',
                  type: 'number',

                  placeholder: 'Enter Backlogs',
                  min: 0
                }
              },
              {
                className: 'col-md-6',
                key: 'phdMarks.startDate',
                type: 'date',
                templateOptions: {
                  label: 'Start Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    max: 'Start date should be less than End date'
                  }
                },
                expressionProperties: {
                  "templateOptions.min": (model) => {
                    if (model?.postgraduateMarks?.endDate !== null) {
                      return model.postgraduateMarks.endDate;
                    }
                    return null;
                  },
                  "templateOptions.max": (model) => {
                    if (model?.phdMarks.endDate !== null) {
                      return model.phdMarks.endDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }
              },

              {
                className: 'col-md-6',
                key: 'phdMarks.endDate',
                type: 'date',
                templateOptions: {
                  label: 'End Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    min: 'End date should be greater than Start date'
                  },
                },
                expressionProperties: {
                  'templateOptions.disabled': 'model.phdMarks.currentlyStudying && model.highestLevel === "phd"',
                  "templateOptions.min": (model) => {
                    if (model?.phdMarks.startDate !== null) {
                      const startDate = new Date(model.phdMarks.startDate);
                      startDate.setDate(startDate.getDate() + 1);
                      return startDate.toISOString().split("T")[0];
                    }
                    return null;
                  },
                  "templateOptions.max": () => {
                    return this.getCurrentDateFormatted();
                  }
                }
              },
              {
                className: 'col-md-12',
                key: 'phdMarks.currentlyStudying',
                type: 'checkbox',
                templateOptions: {
                  label: 'I am currently studying here',
                  indeterminate: false
                },
                hideExpression: 'model.highestLevel !== "phd"'
              }

            ],
            hideExpression: 'model.highestLevel !== "phd"'
          },

          // Postgraduate Section
          {
            template: '<h5 class="mb-3 mt-6">Postgraduate Details</h5>',
            className: 'col-12',
            hideExpression: 'model.highestLevel !== "phd" && model.highestLevel !== "postgraduate"'
          },
          {
            fieldGroupClassName: 'row mt-2',
            fieldGroup: [
              {
                className: 'col-md-4',
                key: 'postgraduateMarks.country',
                type: 'select',
                templateOptions: {
                  label: 'Country of Study*',
                  options: this.courseFinderCountryOptions,
                  placeholder: 'Select Country'
                }
              },
              {
                className: 'col-md-4',
                key: 'postgraduateMarks.state',
                type: 'input',
                templateOptions: {
                  label: 'State of Study*',
                  options: this.stateOptions,
                  placeholder: 'Select'
                }
              },
              {
                className: 'col-md-4',
                key: 'postgraduateMarks.level',
                type: 'select',
                templateOptions: {
                  label: 'Level of Study*',
                  options: [
                    { label: 'Postgraduate', value: 'postgraduate' }
                  ],
                  placeholder: 'Select level'
                },
              },

              {
                className: 'col-md-6',
                key: 'postgraduateMarks.postgradCollegeName',
                type: 'input',
                templateOptions: {
                  label: 'Name of University*',

                  placeholder: 'Enter university name'

                }
              },
              {
                className: 'col-md-6',
                key: 'postgraduateMarks.degreeType',
                type: 'input',
                templateOptions: {
                  label: 'Qualification Achieved/ Degree Awarded*',

                  placeholder: 'eg. M.Tech, M.E., M.Sc.'
                }
              },
              {
                className: 'col-md-6',
                key: 'postgraduateMarks.city',
                type: 'input',
                templateOptions: {
                  label: 'City of Study*',

                  placeholder: 'Enter city'
                }
              },
              {
                className: 'col-md-3',
                key: 'postgraduateMarks.scoreSystem',
                type: 'select',
                templateOptions: {
                  label: 'Grading system & Marks scored*',

                  options: this.gradingSystemOptions,
                  placeholder: 'Select'
                }
              },
              {
                className: 'col-md-3 custom-margin-top',
                key: 'postgraduateMarks.score',
                type: 'input',
                templateOptions: {
                  type: 'number',
                  label: 'Score*',
                  placeholder: 'Enter Marks'
                },
                expressionProperties: {
                  'templateOptions.min': '0',
                  'templateOptions.max': 'model.postgraduateMarks.scoreSystem'
                },
                validation: {
                  messages: {
                    min: 'Score must be at least 0',
                    max: 'Score cannot exceed the max Score value'
                  }
                }
              },
              {
                className: 'col-md-6',
                key: 'postgraduateMarks.language',
                type: 'input',
                templateOptions: {
                  label: 'Primary Language of Instruction*',

                  placeholder: 'Enter Language'
                }
              },
              {
                className: 'col-md-6',
                key: 'postgraduateMarks.degreeBacklogs',
                type: 'input',
                templateOptions: {
                  label: 'Backlogs*',
                  type: 'number',

                  placeholder: 'Enter Backlogs',
                  min: 0
                }
              },

              {
                className: 'col-md-6',
                key: 'postgraduateMarks.startDate',
                type: 'date',
                templateOptions: {
                  label: 'Start Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    max: 'Start date should be less than End date'
                  }
                },
                expressionProperties: {
                  "templateOptions.min": (model) => {
                    // Must start after undergraduate ends
                    if (model?.undergraduateMarks?.endDate !== null) {
                      return model.undergraduateMarks.endDate;
                    }
                    return null;
                  },
                  "templateOptions.max": (model) => {
                    // Can't start after its own end date
                    if (model?.postgraduateMarks.endDate !== null) {
                      return model.postgraduateMarks.endDate;
                    }
                    // Can't start after PhD starts
                    if (model?.phdMarks?.startDate !== null) {
                      return model.phdMarks.startDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }
              },

              {
                className: 'col-md-6',
                key: 'postgraduateMarks.endDate',
                type: 'date',
                templateOptions: {
                  label: 'End Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    min: 'End date should be greater than Start date'
                  },
                },
                expressionProperties: {
                  'templateOptions.disabled': 'model.postgraduateMarks.currentlyStudying && model.highestLevel === "postgraduate"',
                  "templateOptions.min": (model) => {
                    // Must end after its own start date
                    if (model?.postgraduateMarks.startDate !== null) {
                      const startDate = new Date(model.postgraduateMarks.startDate);
                      startDate.setDate(startDate.getDate() + 1);
                      return startDate.toISOString().split("T")[0];
                    }
                    return null;
                  },
                  "templateOptions.max": (model) => {
                    // Can't end after PhD starts
                    if (model?.phdMarks?.startDate !== null) {
                      return model.phdMarks.startDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }

              },


              {
                className: 'col-md-12',
                key: 'postgraduateMarks.currentlyStudying',
                type: 'checkbox',
                templateOptions: {
                  label: 'I am currently studying here',
                  indeterminate: false
                },
                hideExpression: 'model.highestLevel !== "postgraduate"'
              },

            ],
            hideExpression: 'model.highestLevel !== "phd" && model.highestLevel !== "postgraduate"'
          },

          //Undergraduate Section
          {
            template: '<h5 class="mb-3 mt-6">Undergraduate Details</h5>',
            className: 'col-12',
            hideExpression: 'model.highestLevel !== "phd" && model.highestLevel !== "postgraduate" && model.highestLevel !== "undergraduate"'
          },
          {
            fieldGroupClassName: 'row mt-2',
            fieldGroup: [
              {
                className: 'col-md-4',
                key: 'undergraduateMarks.country',
                type: 'select',
                templateOptions: {
                  label: 'Country of Study*',
                  options: this.courseFinderCountryOptions,
                  placeholder: 'Select Country'
                }
              },
              {
                className: 'col-md-4',
                key: 'undergraduateMarks.state',
                type: 'input',
                templateOptions: {
                  label: 'State of Study*',

                  options: this.stateOptions,
                  placeholder: 'Select'
                }
              },
              {
                className: 'col-md-4',
                key: 'undergraduateMarks.level',
                type: 'select',
                templateOptions: {
                  label: 'Level of Study*',
                  options: [
                    { label: 'Undergraduate', value: 'undergraduate' }
                  ],
                  placeholder: 'Select level'
                }
              },
              {
                className: 'col-md-6',
                key: 'undergraduateMarks.undergradCollegeName',
                type: 'input',
                templateOptions: {
                  label: 'Name of University*',

                  placeholder: 'Enter university name'
                }
              },
              {
                className: 'col-md-6',
                key: 'undergraduateMarks.degreeType',
                type: 'input',
                templateOptions: {
                  label: 'Qualification Achieved/ Degree Awarded*',

                  placeholder: 'eg. B.Tech, B.E., B.Sc.'
                }
              },
              {
                className: 'col-md-6',
                key: 'undergraduateMarks.city',
                type: 'input',
                templateOptions: {
                  label: 'City of Study*',

                  placeholder: 'Enter city'
                }
              },
              {
                className: 'col-md-3',
                key: 'undergraduateMarks.scoreSystem',
                type: 'select',
                templateOptions: {
                  label: 'Grading system & Marks scored*',

                  options: this.gradingSystemOptions,
                  placeholder: 'Select'
                }
              },
              {
                className: 'col-md-3 custom-margin-top',
                key: 'undergraduateMarks.score',
                type: 'input',
                templateOptions: {
                  type: 'number',
                  label: 'Score*',
                  placeholder: 'Enter Marks'
                },
                expressionProperties: {
                  'templateOptions.min': '0',
                  'templateOptions.max': 'model.undergraduateMarks.scoreSystem'
                },
                validation: {
                  messages: {
                    min: 'Score must be at least 0',
                    max: 'Score cannot exceed the max Score value'
                  }
                }
              },
              {
                className: 'col-md-6',
                key: 'undergraduateMarks.language',
                type: 'input',
                templateOptions: {
                  label: 'Primary Language of Instruction*',

                  placeholder: 'Enter Language'
                }
              },
              {
                className: 'col-md-6',
                key: 'undergraduateMarks.degreeBacklogs',
                type: 'input',
                templateOptions: {
                  label: 'Backlogs*',
                  type: 'number',

                  placeholder: 'Enter Backlogs',
                  min: 0
                }
              },
              {
                className: 'col-md-6',
                key: 'undergraduateMarks.startDate',
                type: 'date',
                templateOptions: {
                  label: 'Start Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    max: 'Start date should be less than End date'
                  }
                },
                expressionProperties: {
                  "templateOptions.min": (model) => {
                    // Must start after 12th grade ends
                    if (model?.highSchoolMarks?.endDate !== null) {
                      return model.highSchoolMarks.endDate;
                    }
                    return null;
                  },
                  "templateOptions.max": (model) => {
                    // Can't start after its own end date
                    if (model?.undergraduateMarks.endDate !== null) {
                      return model.undergraduateMarks.endDate;
                    }
                    // Can't start after postgraduate starts
                    if (model?.postgraduateMarks?.startDate !== null) {
                      return model.postgraduateMarks.startDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }
              },
              {
                className: 'col-md-6',
                key: 'undergraduateMarks.endDate',
                type: 'date',
                templateOptions: {
                  label: 'End Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    min: 'End date should be greater than Start date'
                  },
                },
                expressionProperties: {
                  'templateOptions.disabled': 'model.undergraduateMarks.currentlyStudying && model.highestLevel === "undergraduate"',
                  "templateOptions.min": (model) => {
                    // Must end after its own start date
                    if (model?.undergraduateMarks.startDate !== null) {
                      const startDate = new Date(model.undergraduateMarks.startDate);
                      startDate.setDate(startDate.getDate() + 1);
                      return startDate.toISOString().split("T")[0];
                    }
                    return null;
                  },
                  "templateOptions.max": (model) => {
                    // Can't end after postgraduate starts
                    if (model?.postgraduateMarks?.startDate !== null) {
                      return model.postgraduateMarks.startDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }
              },

              {
                className: 'col-md-12',
                key: 'undergraduateMarks.currentlyStudying',
                type: 'checkbox',
                templateOptions: {
                  label: 'I am currently studying here',
                  indeterminate: false
                },
                hideExpression: 'model.highestLevel !== "undergraduate"'
              },
            ],
            hideExpression: 'model.highestLevel !== "phd" && model.highestLevel !== "postgraduate" && model.highestLevel !== "undergraduate"'
          },

          //12th Grade Section
          {
            template: '<h5 class="mb-3 mt-6">Grade 12th or Equivalent</h5>',
            className: 'col-12',
            hideExpression: 'model.highestLevel !== "phd" && model.highestLevel !== "postgraduate" && model.highestLevel !== "undergraduate" && model.highestLevel !== "grade12"'
          },
          {
            fieldGroupClassName: 'row mt-2',
            fieldGroup: [
              {
                className: 'col-md-4',
                key: 'highSchoolMarks.country',
                type: 'select',
                templateOptions: {
                  label: 'Country of Study*',
                  options: this.courseFinderCountryOptions,
                  placeholder: 'Select Country',
                  click: () => {
                    setTimeout(async () => {
                      if (this.model?.highSchoolMarks?.country && this.model?.highSchoolMarks?.country !== this.previousHighSchoolCountry) {

                        this.previousHighSchoolCountry = this.model?.highSchoolMarks?.country;

                        if (this.model?.highSchoolMarks?.state !== undefined) {
                          this.model.highSchoolMarks.state = undefined;
                          this.model.highSchoolMarks.state = null;
                        }
                        if (this.model?.highSchoolMarks?.boardName !== undefined) {
                          this.model.highSchoolMarks.boardName = undefined;
                          this.model.highSchoolMarks.boardName = null;
                        }

                        await this.loadStatesByCountry(this.previousHighSchoolCountry).then((res: any) => {
                          if (res?.data?.length > 0) {
                            this.showhighSchoolStateAndBoardInput = true;
                            this.highSchoolStateOptions = res?.data?.map((item: any) => ({
                              label: item.state,
                              value: item.state
                            }));
                          }
                          else {
                            this.showhighSchoolStateAndBoardInput = false;
                            this.highSchoolStateOptions = [];
                          }

                          let newModel = { ...this.model };
                          const preservedHighestLevel = this.model.highestLevel;
                          this.model = undefined;
                          this.model = newModel;
                          this.model.highestLevel = preservedHighestLevel;
                          this.cd.detectChanges();
                        })

                        this.layoutEducation = undefined;
                        this.loading = true;

                        let newModel = { ...this.model };
                        const preservedHighestLevel = this.model.highestLevel;
                        this.model = undefined;
                        this.model = newModel;
                        this.model.highestLevel = preservedHighestLevel;

                        setTimeout(() => {
                          this.setLayout();
                          this.loading = false;
                        }, 100);

                      }
                    }, 100);
                  }
                }
              },

              {
                className: 'col-md-4',
                key: 'highSchoolMarks.state',
                type: 'select',
                templateOptions: {
                  label: 'State of Study*',
                  placeholder: 'Select State',
                  options: this.highSchoolStateOptions,
                  click: () => {
                    setTimeout(() => {
                      if (this.model?.highSchoolMarks?.state && this.model?.highSchoolMarks?.state !== this.previousHighSchoolState) {
                        this.previousHighSchoolState = this.model?.highSchoolMarks?.state;

                        if (this.model?.highSchoolMarks?.boardName !== undefined) {
                          this.model.highSchoolMarks.boardName = undefined;
                          this.model.highSchoolMarks.boardName = null;
                        }

                        this.loadBoardsByStateAndCountry(this.previousHighSchoolCountry, this.previousHighSchoolState).then((res: any) => {
                          if (res?.data?.length > 0) {
                            const matchedState = res.data.find((item: any) => item.state === this.previousHighSchoolState);
                            this.highSchoolBoardOptions = matchedState?.educationBoards || [];
                          } else {
                            this.highSchoolBoardOptions = [];
                          }
                        })

                        this.layoutEducation = undefined;
                        this.loading = true;

                        let newModel = { ...this.model };
                        this.model = undefined;
                        this.model = newModel;

                        setTimeout(() => {
                          this.setLayout();
                          this.loading = false;
                        }, 100);

                      }
                    }, 100);
                  },

                },
                hideExpression: () => {
                  if (this.showhighSchoolStateAndBoardInput) {
                    return false;
                  }
                  return true;
                }
              },

              {
                className: "col-md-4",
                key: 'highSchoolMarks.state',
                type: 'input',
                templateOptions: {
                  label: 'State of Study*',
                  placeholder: 'Enter state',
                },
                hideExpression: () => {
                  if (this.showhighSchoolStateAndBoardInput) {
                    return true;
                  }
                  return false;
                }
              },

              {
                className: 'col-md-4',
                key: 'highSchoolMarks.level',
                type: 'select',
                templateOptions: {
                  label: 'Level of Study*',
                  options: [
                    { label: 'Grade 12', value: 'grade12' }
                  ],
                  placeholder: 'Select level'
                }
              },

              {
                className: 'col-md-6',
                key: 'highSchoolMarks.boardName',
                type: 'select',
                templateOptions: {
                  label: 'Name of Board*',
                  placeholder: 'Search and Select Board',
                  options: this.highSchoolBoardOptions
                },
                hideExpression: () => {
                  if (this.showhighSchoolStateAndBoardInput) {
                    return false;
                  }
                  return true;
                }
              },

              {
                className: "col-md-6",
                key: 'highSchoolMarks.boardName',
                type: 'input',
                templateOptions: {
                  label: 'Name of Board*',
                  placeholder: 'Enter board',
                },
                hideExpression: () => {
                  if (this.showhighSchoolStateAndBoardInput) {
                    return true;
                  }
                  return false;
                }
              },

              {
                className: 'col-md-6',
                key: 'highSchoolMarks.degreeType',
                type: 'input',
                templateOptions: {
                  label: 'Qualification Achieved/ Degree Awarded*',
                  placeholder: 'eg. 12th, HSC, etc.'
                }
              },

              {
                className: 'col-md-6',
                key: 'highSchoolMarks.highSchoolName',
                type: 'input',
                templateOptions: {
                  label: 'Name of Institution*',
                  placeholder: 'Enter institution name'
                }
              },

              {
                className: 'col-md-6',
                key: 'highSchoolMarks.city',
                type: 'input',
                templateOptions: {
                  label: 'City of Study*',
                  placeholder: 'Enter city'
                }
              },

              {
                className: 'col-md-3',
                key: 'highSchoolMarks.highSchoolScoreSystem',
                type: 'select',
                templateOptions: {
                  label: 'Grading system & Marks scored*',
                  options: this.gradingSystemOptions,
                  placeholder: 'Select'
                }
              },

              {
                className: 'col-md-3 custom-margin-top',
                key: 'highSchoolMarks.highSchoolScore',
                type: 'input',
                templateOptions: {
                  type: 'number',
                  label: 'Score*',
                  placeholder: 'Enter Marks'
                },
                expressionProperties: {
                  'templateOptions.min': '0',
                  'templateOptions.max': 'model.highSchoolMarks.highSchoolScoreSystem'
                },
                validation: {
                  messages: {
                    min: 'Score must be at least 0',
                    max: 'Score cannot exceed the max Score value'
                  }
                }
              },

              {
                className: 'col-md-6',
                key: 'highSchoolMarks.language',
                type: 'input',
                templateOptions: {
                  label: 'Primary Language of Instruction*',

                  placeholder: 'Enter Language'
                }
              },

              {
                className: 'col-md-6',
                key: 'highSchoolMarks.startDate',
                type: 'date',
                templateOptions: {
                  label: 'Start Date*',
                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    max: 'Start date should be less than End date',
                    min: 'Start date should be after 10th grade completion'
                  }
                },
                expressionProperties: {
                  "templateOptions.min": (model) => {
                    // Must start after 10th grade ends
                    if (model?.grade10?.endDate) {
                      return model.grade10.endDate;
                    }
                    return null;
                  },
                  "templateOptions.max": (model) => {
                    // Can't start after its own end date
                    if (model?.highSchoolMarks.endDate) {
                      return model.highSchoolMarks.endDate;
                    }
                    // Can't start after undergraduate starts
                    if (model?.undergraduateMarks?.startDate) {
                      return model.undergraduateMarks.startDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }
              },

              {
                className: 'col-md-6',
                key: 'highSchoolMarks.endDate',
                type: 'date',
                templateOptions: {
                  label: 'End Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    min: 'End date should be greater than Start date'
                  },
                },
                expressionProperties: {
                  'templateOptions.disabled': 'model.highSchoolMarks.currentlyStudying && model.highestLevel === "grade12"',
                  "templateOptions.min": (model) => {
                    // Must end after its own start date
                    if (model?.highSchoolMarks.startDate !== null) {
                      const startDate = new Date(model.highSchoolMarks.startDate);
                      startDate.setDate(startDate.getDate() + 1);
                      return startDate.toISOString().split("T")[0];
                    }
                    return null;
                  },
                  "templateOptions.max": (model) => {
                    // Can't end after PhD starts
                    if (model?.undergraduateMarks?.startDate !== null) {
                      return model.undergraduateMarks.startDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }

              },

              {
                className: 'col-md-12',
                key: 'highSchoolMarks.currentlyStudying',
                type: 'checkbox',
                templateOptions: {
                  label: 'I am currently studying here',
                  indeterminate: false
                },
                hideExpression: 'model.highestLevel !== "grade12"'
              },
            ],
            hideExpression: 'model.highestLevel !== "phd" && model.highestLevel !== "postgraduate" && model.highestLevel !== "undergraduate" && model.highestLevel !== "grade12"'
          },

          //10th Grade Section
          {
            template: '<h5 class="mb-3 mt-6">Grade 10th or Equivalent</h5>',
            className: 'col-12',
          },
          {
            fieldGroupClassName: 'row mt-2',
            fieldGroup: [
              {
                className: 'col-md-4',
                key: 'grade10.country',
                type: 'select',
                templateOptions: {
                  label: 'Country of Study*',
                  options: this.courseFinderCountryOptions,
                  placeholder: 'Select Country',
                  click: () => {
                    setTimeout(async () => {
                      if (this.model?.grade10?.country && this.model?.grade10?.country !== this.previousTenthGradeCountry) {
                        this.previousTenthGradeCountry = this.model?.grade10?.country;

                        if (this.model?.grade10?.state !== undefined) {
                          this.model.grade10.state = undefined;
                          this.model.grade10.state = null;
                        }
                        if (this.model?.grade10?.boardName !== undefined) {
                          this.model.grade10.boardName = undefined;
                          this.model.grade10.boardName = null;
                        }

                        await this.loadStatesByCountry(this.previousTenthGradeCountry).then((res: any) => {
                          if (res?.data?.length > 0) {
                            this.showSchoolStateAndBoardInput10 = true;
                            this.tenthGradeStateOptions = res?.data?.map((item: any) => ({
                              label: item.state,
                              value: item.state
                            }));
                          }
                          else {
                            this.showSchoolStateAndBoardInput10 = false;
                            this.tenthGradeStateOptions = [];
                          }

                          let newModel = { ...this.model };
                          const preservedHighestLevel = this.model.highestLevel;
                          this.model = undefined;
                          this.model = newModel;
                          this.model.highestLevel = preservedHighestLevel;
                          this.cd.detectChanges();
                        })

                        this.layoutEducation = undefined;
                        this.loading = true;

                        let newModel = { ...this.model };
                        const preservedHighestLevel = this.model.highestLevel;
                        this.model = undefined;
                        this.model = newModel;
                        this.model.highestLevel = preservedHighestLevel;

                        setTimeout(() => {
                          this.setLayout();
                          this.loading = false;
                        }, 100);
                      }
                    }, 100);
                  }
                }
              },

              {
                className: 'col-md-4',
                key: 'grade10.state',
                type: 'select',
                templateOptions: {
                  label: 'State of Study*',
                  placeholder: 'Select State',
                  options: this.tenthGradeStateOptions,
                  click: () => {
                    setTimeout(() => {
                      if (this.model?.grade10?.state && this.model?.grade10?.state !== this.previousTenthGradeState) {
                        this.previousTenthGradeState = this.model?.grade10?.state;

                        if (this.model?.grade10?.boardName !== undefined) {
                          this.model.grade10.boardName = undefined;
                          this.model.grade10.boardName = null;
                        }

                        this.loadBoardsByStateAndCountry(this.previousTenthGradeCountry, this.previousTenthGradeState).then((res: any) => {
                          if (res?.data?.length > 0) {
                            const matchedState = res.data.find((item: any) => item.state === this.previousTenthGradeState);
                            this.tenthSchoolBoardOptions = matchedState?.educationBoards || [];
                          } else {
                            this.tenthSchoolBoardOptions = [];
                          }
                        })

                        this.layoutEducation = undefined;
                        this.loading = true;

                        let newModel = { ...this.model };
                        this.model = undefined;
                        this.model = newModel;

                        setTimeout(() => {
                          this.setLayout();
                          this.loading = false;
                        }, 100)

                      }
                    }, 100)
                  }
                },
                hideExpression: () => {
                  if (this.showSchoolStateAndBoardInput10) {
                    return false;
                  }
                  return true;
                }
              },

              {
                className: 'col-md-4',
                key: 'grade10.state',
                type: 'input',
                templateOptions: {
                  label: 'State of Study*',
                  placeholder: 'Enter state'
                },
                hideExpression: () => {
                  if (this.showSchoolStateAndBoardInput10) {
                    return true;
                  }
                  return false;
                }
              },

              {
                className: 'col-md-4',
                key: 'grade10.level',
                type: 'select',
                templateOptions: {
                  label: 'Level of Study*',
                  options: [
                    { label: 'Grade 10', value: 'grade10' }
                  ],
                  placeholder: 'Select level'
                }
              },

              {
                className: 'col-md-6',
                key: 'grade10.boardName',
                type: 'select',
                templateOptions: {
                  label: 'Name of Board*',
                  placeholder: 'Search and Select Board',
                  options: this.tenthSchoolBoardOptions
                },
                hideExpression: () => {
                  if (this.showSchoolStateAndBoardInput10) {
                    return false;
                  }
                  return true;
                }

              },

              {
                className: 'col-md-6',
                key: 'grade10.boardName',
                type: 'input',
                templateOptions: {
                  label: 'Name of Board*',
                  placeholder: 'Enter board name'
                },
                hideExpression: () => {
                  if (this.showSchoolStateAndBoardInput10) {
                    return true;
                  }
                  return false;
                }
              },

              {
                className: 'col-md-6',
                key: 'grade10.degreeType',
                type: 'input',
                templateOptions: {
                  label: 'Qualification Achieved/ Degree Awarded*',

                  placeholder: 'eg. 10th, SSC, etc.'
                }
              },

              {
                className: 'col-md-6',
                key: 'grade10.schoolName',
                type: 'input',
                templateOptions: {
                  label: 'Name of Institution*',

                  placeholder: 'Enter institution name'
                }
              },

              {
                className: 'col-md-6',
                key: 'grade10.city',
                type: 'input',
                templateOptions: {
                  label: 'City of Study*',

                  placeholder: 'Enter city'
                }
              },

              {
                className: 'col-md-3',
                key: 'grade10.schoolScoreSystem',
                type: 'select',
                templateOptions: {
                  label: 'Grading system & Marks scored*',
                  options: this.gradingSystemOptions,
                  placeholder: 'Select'
                }
              },

              {
                className: 'col-md-3 custom-margin-top',
                key: 'grade10.schoolScore',
                type: 'input',
                templateOptions: {
                  type: 'number',
                  label: 'Score*',
                  placeholder: 'Enter Marks'
                },
                expressionProperties: {
                  'templateOptions.min': '0',
                  'templateOptions.max': 'model.grade10.schoolScoreSystem'
                },
                validation: {
                  messages: {
                    min: 'Score must be at least 0',
                    max: 'Score cannot exceed the max Score value'
                  }
                }
              },

              {
                className: 'col-md-6',
                key: 'grade10.language',
                type: 'input',
                templateOptions: {
                  label: 'Primary Language of Instruction*',

                  placeholder: 'Enter Language'
                }
              },

              {
                className: 'col-md-6',
                key: 'grade10.startDate',
                type: 'date',
                templateOptions: {
                  label: 'Start Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    max: 'Start date should be less than End date'
                  }
                },
                expressionProperties: {
                  "templateOptions.max": (model) => {
                    if (model?.grade10.endDate !== null) {
                      return model.grade10.endDate;
                    }
                    if (model?.highSchoolMarks?.startDate !== null) {
                      return model.highSchoolMarks.startDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }
              },

              {
                className: 'col-md-6',
                key: 'grade10.endDate',
                type: 'date',
                templateOptions: {
                  label: 'End Date*',

                  placeholder: 'Choose date'
                },
                validation: {
                  messages: {
                    min: 'End date should be greater than Start date'
                  },
                },
                expressionProperties: {
                  'templateOptions.disabled': 'model.grade10.currentlyStudying && model.highestLevel === "grade10"',
                  "templateOptions.min": (model) => {
                    if (model?.grade10.startDate !== null) {
                      const startDate = new Date(model.grade10.startDate);
                      startDate.setDate(startDate.getDate() + 1);
                      return startDate.toISOString().split("T")[0];
                    }
                    return null;
                  },
                  "templateOptions.max": (model) => {
                    if (model?.highSchoolMarks?.startDate !== null) {
                      return model.highSchoolMarks.startDate;
                    }
                    return this.getCurrentDateFormatted();
                  }
                }
              },

              {
                className: 'col-md-12',
                key: 'grade10.currentlyStudying',
                type: 'checkbox',
                templateOptions: {
                  label: 'I am currently studying here',
                  indeterminate: false
                },
                hideExpression: 'model.highestLevel !== "grade10"'
              },
            ],
            hideExpression: '!model.highestLevel'
          },

          {
            fieldGroupClassName: 'fixed-bottom-button-containers',
            fieldGroup: [
              {
                fieldGroup: [
                  {
                    type: 'button',
                    templateOptions: {
                      btnType: 'primary px-5 ',
                      type: 'submit',
                      text: 'Save Changes'
                    },
                    hideExpression: () => !this.saveChangesEducation
                  }
                ]
              }
            ]
          },

        ]
      }
    ];

    setTimeout(() => {
      this.layoutEducation = [...layoutEducation];
    },)
  }

  getCurrentDateFormatted() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getEducationLevelLabel(value: string): string {
    if (!value) return '';

    const option = this.educationLevelOptions.find(opt => opt.value === value);
    return option ? option.label : value;
  }


  async dataPreProcessor() {
    // Start with a complete model structure with all required nested objects
    const defaultModel = {
      countryOfEducation: null,
      highestLevel: null,
      grade10: {
        country: null,
        state: null,
        level: 'grade10',
        boardName: null,
        degreeType: null,
        schoolName: null,
        city: null,
        schoolScoreSystem: null,
        schoolScore: null,
        language: null,
        startDate: null,
        endDate: null,
      },
      highSchoolMarks: {
        country: null,
        state: null,
        level: 'grade12',
        boardName: null,
        degreeType: null,
        highSchoolName: null,
        city: null,
        highSchoolScoreSystem: null,
        highSchoolScore: null,
        language: null,
        startDate: null,
        endDate: null,
      },
      undergraduateMarks: {
        country: null,
        state: null,
        level: 'undergraduate',
        undergradCollegeName: null,
        degreeType: null,
        city: null,
        scoreSystem: null,
        score: null,
        language: null,
        degreeBacklogs: 0,
        startDate: null,
        endDate: null,
      },
      postgraduateMarks: {
        country: null,
        state: null,
        level: 'postgraduate',
        postgradCollegeName: null,
        degreeType: null,
        city: null,
        scoreSystem: null,
        score: null,
        language: null,
        degreeBacklogs: 0,
        startDate: null,
        endDate: null,
      },
      phdMarks: {
        country: null,
        state: null,
        level: 'phd',
        postgradCollegeName: null,
        degreeType: null,
        city: null,
        scoreSystem: null,
        score: null,
        language: null,
        degreeBacklogs: 0,
        startDate: null,
        endDate: null,
        currentlyStudying: false,
      }
    };


    if (this.userDetails?.academicQualification) {
      // Deep merge to ensure nested objects are properly combined
      this.model = this.deepMerge(defaultModel, this.userDetails.academicQualification);
    } else {
      this.model = defaultModel;
    }

    if (this.model?.highSchoolMarks?.country) {
      this.previousHighSchoolCountry = this.model?.highSchoolMarks?.country;
      await this.loadStatesByCountry(this.previousHighSchoolCountry).then((res: any) => {
        if (res?.data?.length > 0) {
          this.showhighSchoolStateAndBoardInput = true;
          this.highSchoolStateOptions = res?.data?.map((item: any) => ({
            label: item.state,
            value: item.state
          }));
        }
        else {
          this.showhighSchoolStateAndBoardInput = false;
          this.highSchoolStateOptions = [];
        }

        let newModel = { ...this.model };
        this.model = undefined;
        this.model = newModel;
        this.cd.detectChanges();
      });

      if (this.model?.highSchoolMarks?.state) {
        this.previousHighSchoolState = this.model?.highSchoolMarks?.state;
        await this.loadBoardsByStateAndCountry(this.previousHighSchoolCountry, this.previousHighSchoolState).then((res: any) => {
          if (res?.data?.length > 0) {
            const matchedState = res.data.find((item: any) => item.state === this.previousHighSchoolState);
            this.highSchoolBoardOptions = matchedState?.educationBoards || [];
          } else {
            this.highSchoolBoardOptions = [];
          }
        })
      }

      if (this.model?.highSchoolMarks?.boardName) {
        this.highSchoolBoardSelected = {
          label: this.model.highSchoolMarks.boardName,
          value: this.model.highSchoolMarks.boardName
        };
      }

    }

    if (this.model?.grade10?.country) {
      this.previousTenthGradeCountry = this.model.grade10.country;
      await this.loadStatesByCountry(this.previousTenthGradeCountry).then((res: any) => {
        if (res?.data?.length > 0) {
          this.showSchoolStateAndBoardInput10 = true;
          this.tenthGradeStateOptions = res?.data?.map((item: any) => ({
            label: item?.state,
            value: item?.state
          }));
        }
        else {
          this.showSchoolStateAndBoardInput10 = false;
          this.tenthGradeStateOptions = [];
        }

        let newModel = { ...this.model };
        this.model = undefined;
        this.model = newModel;
        this.cd.detectChanges();
      });

      if (this.model?.grade10?.state) {
        this.previousTenthGradeState = this.model?.grade10?.state;
        await this.loadBoardsByStateAndCountry(this.previousTenthGradeCountry, this.previousTenthGradeState).then((res: any) => {
          if (res?.data?.length > 0) {
            const matchedState = res.data.find((item: any) => item.state === this.previousTenthGradeState);
            this.tenthSchoolBoardOptions = matchedState?.educationBoards || [];
          } else {
            this.tenthSchoolBoardOptions = [];
          }

        })
      }

      if (this.model?.grade10?.boardName) {
        this.tenthGradeBoardSelected = {
          label: this.model.grade10.boardName,
          value: this.model.grade10.boardName
        };
      }
    }

    this.setLayout();

  }

  // Helper method for deep merging objects
  deepMerge(target, source) {
    const output = Object.assign({}, target);

    if (target && typeof target === 'object' && !Array.isArray(target) &&
      source && typeof source === 'object' && !Array.isArray(source)) {
      Object.keys(source).forEach(key => {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
          if (!(key in target)) {
            Object.assign(output, { [key]: source[key] });
          } else {
            output[key] = this.deepMerge(target[key], source[key]);
          }
        } else {
          Object.assign(output, { [key]: source[key] });
        }
      });
    }

    return output;
  }



  dataProcessor(data) {
    return data;
  }

  onSubmit(event?: any) {
    if (event?.error) {
      console.error('Form submission error:', event.error);
    } else {
      let obj = {
        academicQualification: {
          countryOfEducation: this.model.countryOfEducation || null,
          highestLevel: this.model.highestLevel || null,
          grade10: {
            country: this.model.grade10?.country || null,
            state: this.model.grade10?.state || null,
            level: this.model.grade10?.level || 'Grade 10',
            boardName: this.model.grade10?.boardName || 'Grade 10',
            degreeType: this.model.grade10?.degreeType || null,
            schoolName: this.model.grade10?.schoolName || null,
            city: this.model.grade10?.city || null,
            schoolScoreSystem: this.model.grade10?.schoolScoreSystem || null,
            schoolScore: this.model.grade10?.schoolScore || null,
            language: this.model.grade10?.language || null,
            startDate: this.model.grade10?.startDate || null,
            endDate: this.model.grade10?.endDate || null,
          },
          highSchoolMarks: {
            country: this.model.highSchoolMarks?.country || null,
            state: this.model.highSchoolMarks?.state || null,
            level: this.model.highSchoolMarks?.level || 'Grade 12',
            boardName: this.model.highSchoolMarks?.boardName || 'Grade 12',
            degreeType: this.model.highSchoolMarks?.degreeType || null,
            highSchoolName: this.model.highSchoolMarks?.highSchoolName || null,
            city: this.model.highSchoolMarks?.city || null,
            highSchoolScoreSystem: this.model.highSchoolMarks?.highSchoolScoreSystem || null,
            highSchoolScore: this.model.highSchoolMarks?.highSchoolScore || null,
            language: this.model.highSchoolMarks?.language || null,
            startDate: this.model.highSchoolMarks?.startDate || null,
            endDate: this.model.highSchoolMarks?.endDate || null,
          },
          undergraduateMarks: {
            country: this.model.undergraduateMarks?.country || null,
            state: this.model.undergraduateMarks?.state || null,
            level: this.model.undergraduateMarks?.level || 'Undergraduate',
            undergradCollegeName: this.model.undergraduateMarks?.undergradCollegeName || null,
            degreeType: this.model.undergraduateMarks?.degreeType || null,
            city: this.model.undergraduateMarks?.city || null,
            scoreSystem: this.model.undergraduateMarks?.scoreSystem || null,
            score: this.model.undergraduateMarks?.score || null,
            language: this.model.undergraduateMarks?.language || null,
            degreeBacklogs: this.model.undergraduateMarks?.degreeBacklogs || 0,
            startDate: this.model.undergraduateMarks?.startDate || null,
            endDate: this.model.undergraduateMarks?.endDate || null,
          },
          postgraduateMarks: {
            country: this.model.postgraduateMarks?.country || null,
            state: this.model.postgraduateMarks?.state || null,
            level: this.model.postgraduateMarks?.level || 'Postgraduate',
            postgradCollegeName: this.model.postgraduateMarks?.postgradCollegeName || null,
            degreeType: this.model.postgraduateMarks?.degreeType || null,
            city: this.model.postgraduateMarks?.city || null,
            scoreSystem: this.model.postgraduateMarks?.scoreSystem || null,
            score: this.model.postgraduateMarks?.score || null,
            language: this.model.postgraduateMarks?.language || null,
            degreeBacklogs: this.model.postgraduateMarks?.degreeBacklogs || 0,
            startDate: this.model.postgraduateMarks?.startDate || null,
            endDate: this.model.postgraduateMarks?.endDate || null,
          },
          phdMarks: {
            country: this.model.phdMarks?.country || null,
            state: this.model.phdMarks?.state || null,
            level: this.model.phdMarks?.level || 'phd',
            postgradCollegeName: this.model.phdMarks?.postgradCollegeName || null,
            degreeType: this.model.phdMarks?.degreeType || null,
            city: this.model.phdMarks?.city || null,
            scoreSystem: this.model.phdMarks?.scoreSystem || null,
            score: this.model.phdMarks?.score || null,
            language: this.model.phdMarks?.language || null,
            degreeBacklogs: this.model.phdMarks?.degreeBacklogs || 0,
            startDate: this.model.phdMarks?.startDate || null,
            endDate: this.model.phdMarks?.endDate || null,
            currentlyStudying: this.model.phdMarks?.currentlyStudying || false
          }
        }
      };

      console.info("=== SAVING ACADEMIC DATA ===");
      console.info("highestLevel:", obj.academicQualification.highestLevel);
      console.info("phdMarks:", obj.academicQualification.phdMarks);
      console.info("Full object:", obj);
      console.info("========================");

      this.isLoading = true;
      this.apiHelper.updateDatawithShortlistingUrl('university-students', this.studentDetails._id, obj)
        .subscribe(
          (res: any) => {
            if (res && res.updatedApplicant) {
              this.userDetails = res.updatedApplicant;
              this.studentDetails = res.updatedApplicant;
              this.model = {
                ...res.updatedApplicant.academicQualification,
              };

              this.saveChangesEducation = false;
              this.isLoading = false;

              // this.cd.detectChanges();
            } else {
              console.error('Update response invalid:', res);
              this.isLoading = false;
            }
          },
          (error) => {
            console.error('Update error:', error);
            this.isLoading = false;
          }
        );

      this.updatedProfileData.emit(true);

    }
  }

  removeEmpty(obj) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      } else if (typeof obj[propName] === 'object') {
        this.removeEmpty(obj[propName]);
      }
    }
    return obj;
  }


  loadStatesByCountry(selectedCountry: string): Promise<any> {
    let filter = {
      where: {
        country: selectedCountry
      }
    };

    let encodedFilter = encodeURIComponent(JSON.stringify(filter));

    return this.apiHelper.getDataWithShortlistingUrl(`education-boards/get-education-boards?filter=${encodedFilter}`).then((res: any) => {
      return res;
    });
  }

  loadBoardsByStateAndCountry(selectedCountry: string, selectedState: string): Promise<any> {
    const filter = {
      where: {
        country: selectedCountry,
        state: selectedState
      }
    };

    const encodedFilter = encodeURIComponent(JSON.stringify(filter));

    return this.apiHelper.getDataWithShortlistingUrl(`education-boards/get-education-boards?filter=${encodedFilter}`)
      .then((res: any) => {

        let newModel = { ...this.model };
        this.model = undefined;
        this.model = newModel;
        return res;
      });
  }
}